// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 961px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}

	// user agent
	let deviceFlg = '';
	isUserAgent();

	function isUserAgent() {
		var ua = navigator.userAgent;

		if (ua.search(/iPhone/) != -1 || ua.search(/iPad/) != -1) {
			// iphone, ipad
			deviceFlg = 'apple';
		} else {
			// Andoird, other
			deviceFlg = 'other';
		}
	}



	// dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const menuOpenTarget = document.querySelector('body');
	const closeButton = document.getElementById('js-menu-action-button');

	dropDownButton.addEventListener('click', function() {
		dropDownButton.classList.toggle('is-close')
		menuOpenTarget.classList.toggle('is-menu-open')
	} );

	closeButton.addEventListener('click', function() {
		dropDownButton.classList.remove('is-close')
		menuOpenTarget.classList.remove('is-menu-open')
	} );




	// pagetop
	// --------------------------------------------------------------- //

	function scrollToTop() {
		var scrolled = getScrolled();
		window.scrollTo( 0, Math.floor( scrolled / 2 ) );
		if ( scrolled > 0 ) {
			window.setTimeout( scrollToTop, 30 );
		}
	};

	const pagetopButton   = document.getElementById('js-pagetop')

	pagetopButton.onclick = function() {
		scrollToTop();
	};


	// front page swiper
	// --------------------------------------------------------------- //

	let frontPickupSwiper = new Swiper ('#js-front-swiper', {
		loop: true,
		slidesPerView: 1.2,
		spaceBetween: 16,
		centeredSlides : true,
		breakpoints: {
		960: {
				slidesPerView: 1.25,
				spaceBetween: 16,
			}
		},

		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	} );

	let frontPickupSwiperSingle = new Swiper ('#js-front-swiper-single', {
		loop: false,
		slidesPerView: 1.2,
		spaceBetween: 16,
		centeredSlides : true,
		//SimulateTouch : false,
		breakpoints: {
		960: {
				slidesPerView: 1.25,
				spaceBetween: 16,
			}
		},
	} );


	// sp map links
	// --------------------------------------------------------------- //
//	$('#js-map-links').click(function () {
//		var lat = $(this).data('lat');
//		var lng = $(this).data('lng');
//		var zoom = $(this).data('zoom');
//		var mapDomainApple = 'http://maps.apple.com/maps';
//		var mapDomainGoogle = 'http://maps.google.com/maps';
//		if (deviceFlg == 'apple') {
//			window.open(mapDomainApple, '_blank');
//		} else {
//			window.open(mapDomainGoogle, '_blank');
//		}
//
//		return false;
//	});


	/* form status
	 ----------------------------------------------------------------- */
	$('.js-form-status').click(function () {
		var $val = $(this).val();
		if ($val == 1) {
			$('.js-form-status-toggle').fadeIn('fast');
			$('.js-separation-year').addClass('js-require');
			$('.js-separation-month').addClass('js-require');
			checkFunc();
		} else {
			$('.js-form-status-toggle').hide();
			$('.js-separation-year').removeClass('js-require');
			$('.js-separation-month').removeClass('js-require');
		}
	});

	if ($('input[name=status]:checked').val() == 1) {
		$('.js-form-status-toggle').fadeIn('fast');
		$('.js-separation-year').addClass('js-require');
		$('.js-separation-month').addClass('js-require');
		checkFunc();
	} else {
		$('.js-form-status-toggle').hide();
		$('.js-separation-year').removeClass('js-require');
		$('.js-separation-month').removeClass('js-require');
	}


	/* form
	 ----------------------------------------------------------------- */
//	$('.js-regist--1').click(function () {
//		$('.form-item__target').find('input:eq(0)').prop('checked', true);
//		checkFunc();
////		linkageFunc();
//
//		return false;
//	});
//
//	$('.js-regist--2').click(function () {
//		$('.form-item__target').find('input:eq(1)').prop('checked', true);
//		checkFunc();
////		linkageFunc();
//
//		return false;
//	});
//
////	function linkageFunc() {
////		var serviceText1 = '転職支援サービス';
////		var serviceText2 = 'お仕事相談サービス';
////
////		if ($('.form-item__target').find('input:eq(0)').prop('checked') == true) {
////			$('input[name="service"]').val(serviceText1);
////		} else if ($('.form-item__target').find('input:eq(1)').prop('checked') == true) {
////			$('input[name="service"]').val(serviceText2);
////		}
////	}
//
//	// validation
//	$('.js-form-submit').prop('disabled', true);
//
//	if( $('body').hasClass('home') ) {
//		checkFunc();
//	}
//
//	function checkFunc() {
//		var check = true;
//		$('.js-require').each(function () {
//			if ($(this).val() == '') {
//				check = false;
//			}
//		});
//
//		var $checked_radio_count = $('.form-item-radio').find('input[type="radio"]:checked').length;
//		var $radio_count = $('.form-item-radio').length;
//		if ($checked_radio_count != $radio_count) {
//			check = false;
//		}
//
////		linkageFunc();
//
//		if (!$('.js-form-mail').val().match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
//			check = false;
//		}
//
////		var radio_array2 = [];
////		$('.js-form-status').each(function () {
////			radio_array2.push($(this).prop('checked'));
////		});
////		if (radio_array2.indexOf(true) == -1) {
////			check = false;
////		}
//
//
//		if (check === true) {
//			$('.js-form-submit').prop('disabled', false);
//		} else {
//			$('.js-form-submit').prop('disabled', true);
//		}
//	}
//
//	$(document).on('keydown keyup keypress change', '.js-require', function () {
//		checkFunc();
//	});



	// jquery date picker
	// --------------------------------------------------------------- //

	$.datetimepicker.setLocale('ja');
	$('.js-datepicker').datetimepicker({
		format: 'Y/m/d',
		lang: 'ja',
		timepicker: false,
		className: 'js-datepicker-wrap',
	});

		var now = new Date();
		var year = now.getFullYear();
		var mon = now.getMonth() + 1;
		var day = now.getDate();

		var result = year + '/' + mon + '/' + day;
		$('.js-datepicker').attr('placeholder', result);


	$('.js-add1').click(function () {
		$('.js-add1').hide();
		$('.js-add-date1, .js-add2').show();

		return false;
	});

	$('.js-add2').click(function () {
		$('.js-add2').hide();
		$('.js-add-date2').show();

		return false;
	});


} );



